import React from 'react'
import PropTypes from 'prop-types'
import StyledText from '#components/a/StyledText'
import Headline from '#components/a/Headline'

export function DashboardNote({title, text, children}) {
  return (
    <div className="dashboard-note">
      <Headline importance={5} modifier="category" text={title} />
      <StyledText text={text} />

      {children}
    </div>
  )
}

DashboardNote.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
}

export default DashboardNote
